import { FC } from 'react';
import { observer } from 'mobx-react-lite';

import { store } from 'store';
import { Wallet } from 'types/copyTrading';

import { WalletsFound } from './WalletsFound';

export const WalletsFoundContainer: FC = observer(() => {
  const { scannedWallets, traderIndexByAddress, openTraderCard } = store.galaxyStore;
  const { resetMode } = store.commonStore;

  if (store.commonStore.mode !== 'autopilot' || scannedWallets.length === 0) return null;

  const handleWalletClick = (wallet: Wallet) => {
    // Whitelist ⊂ stars by construction (whitelist traders also appear
    // in /galaxy/stars), so the index lookup should always succeed.
    // Defensive miss-handling is still cheap and protects against any
    // future divergence between the two endpoints.
    const index = traderIndexByAddress.get(wallet.address.toLowerCase());
    if (index === undefined) return;

    // Exit autopilot before opening the trader card. The star:click
    // handler in GalaxyCanvas does the same — without it the autopilot
    // would keep flying the ship and the camera would not track the
    // selected star, defeating the purpose of opening the card.
    resetMode();
    openTraderCard(index);
  };

  return <WalletsFound wallets={scannedWallets} onWalletClick={handleWalletClick} />;
});
